// extracted by mini-css-extract-plugin
module.exports = {"news":"News-module--news--2yUb5","item":"News-module--item--1g9Jb","title":"News-module--title--2NiLR","description":"News-module--description--3cH5B"};